import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'store';

import { useStartSearchMutation } from 'store/queries/search';
import { updateSearchBox } from 'store/slices/searchBox';

const PropertyCard = ({
    className,
    image,
    title,
    subtitle,
    price,
    propertyId,
    destinationId,
    resortId,
    countryId,
    arrival,
    departure,
    url = null,
    id = null,
    onClickHandler,
    restorationRef,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [
        startSearch,
        { data, isLoading, isSuccess },
    ] = useStartSearchMutation();

    const clickHandler = async () => {
        if (!url) {
            const searchBoxData = {
                propertyId,
                resortId,
                destinationId,
                countryId,
                arrival: arrival.toISOString(),
                departure: departure.toISOString(),
                term: `${title}, ${subtitle}`,
            };

            dispatch(updateSearchBox(searchBoxData));

            startSearch({
                countryId,
                destinationId,
                resortId,
                propertyId: null,
                currency: 'GBP',
                term: title,
                arrival: arrival.format('DD/MM/YYYY'),
                departure: departure.format('DD/MM/YYYY'),
                rooms: 1,
                occupancy: [
                    {
                        adults: 2,
                        children: 0,
                        ages: [],
                    },
                ],
            });
        } else {
            onClickHandler(id);
            history.push(url);
        }
    };

    useEffect(() => {
        if (isSuccess && data.sid) {
            history.push(`/search/results.html?sid=${data.sid}`);
        }
    }, [isSuccess, data, history]);

    useEffect(() => {
        // restorationRef is only provided to the ProductCard that needs to be scrolled to
        if (!restorationRef) {
            return;
        }

        // Restoring scroll here ensures the previously selected product will always be restored, no matter how long the API request
        // to get products takes
        restorationRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'center',
        });
    });

    return (
        <div className={className} ref={restorationRef}>
            <div
                className="card"
                style={{ backgroundImage: `url(${image})` }}
                onClick={url || !isLoading ? clickHandler : null}
            >
                <div className="inner">
                    {price && (
                        <div className="price-container">
                            <div className="price">from £{price} pppn</div>
                        </div>
                    )}
                </div>
            </div>

            <span className="title">{title}</span>
            <span className="subtitle">{subtitle}</span>
        </div>
    );
};

export default PropertyCard;
